import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { FrontProfilesService } from '@services/front-profiles/front-profiles.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { GroupService } from '@services/groups/group.service';
import { GroupHasFrontProfileService } from '@services/groups/group-has-frontprofile.service';
import { GroupHasRoleInOrganisationService } from '@services/groups/group-has-role-in-organisation.service';
import { MessengerService } from '@services/messenger/messenger.service';
import { GroupSelectionComponent } from '../../../components/popUpSelects/group-selection/group-selection.component';
import { MatDialog } from '@angular/material/dialog';
import { AccountService } from '@services/accounts/account.service';
import { DataTableComponent } from '../../../components/data-table/data-table.component';

import * as _ from 'lodash';
import phone from 'phone';
import { GroupHasSecuredAppService } from '@services/groups/group-has-secured-app.service';
import { PackageService } from '@services/packages/package.service';
import { AdditionalProfileDataService } from '@services/additional-profile-data/additional-profile-data.service';
import { LabelsService } from '@services/labels/labels.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { UntypedFormControl } from '@angular/forms';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'app-front-profile-edit',
    templateUrl: './front-profile-edit.component.html',
    styleUrls: ['./front-profile-edit.component.scss'],
    providers: [
        FrontProfilesService, GroupService, GroupHasFrontProfileService, GroupHasRoleInOrganisationService, AccountService, GroupHasSecuredAppService, PackageService,
        AdditionalProfileDataService, LabelsService
    ],
    standalone: false
})
export class FrontProfileEditComponent implements OnInit {

  @ViewChild(DataTableComponent) table: DataTableComponent;
  @ViewChild('autocompleteInput', { read: MatAutocompleteTrigger }) autocomplete: MatAutocompleteTrigger;

  public title = 'Edit user';
  public pageActions: PageAction[];

  public profile: Models.FrontProfileModel;
  public columns = [{ prop: 'groupName' }];
  public params: any;
  public isCreate = false;
  public errorMessage: { email: boolean, mobile: boolean, channel: boolean, message: string, name: boolean };
  public additionalFieldConfig: any;
  public additionalFieldKeys: any;
  public additionalProfileData: Models.AdditionalProfileData;
  public labels: Models.Label[];
  public filteredLabels: any;
  private groupHasFrontProfiles: Models.GroupHasFrontProfile[];
  public stateCtrl: UntypedFormControl;

  constructor(
    private frontProfilesService: FrontProfilesService, private accountService: AccountService, private router: Router, private additionalDataService: AdditionalProfileDataService,
    public groupHasFrontProfileService: GroupHasFrontProfileService, private ghrioService: GroupHasRoleInOrganisationService, private ghsaService: GroupHasSecuredAppService,
    private messengerService: MessengerService, private route: ActivatedRoute, private snackbar: SnackbarService, private dialog: MatDialog, private packageService: PackageService,
    private labelService: LabelsService, private dialogService: DialogService
  ) {
    this.params= { ProfileID: this.route.snapshot.params['frontProfileID'] };
    this.stateCtrl = new UntypedFormControl();

    this.stateCtrl.valueChanges.subscribe(val => {
      if (val.length === 0) {
        return this.filteredLabels = _.cloneDeep(this.labels);
      }
      this.filteredLabels = _.filter(this.labels, label => {
        return label.title.toLowerCase().startsWith(val.toLowerCase());
      });
    });
  }

  async ngOnInit() {
    const labels = await this.labelService.find(0, 100, { packageId: this.route.snapshot.params['packageId'] });
    this.labels = labels.data;
    const pak = await this.packageService.get(this.route.snapshot.params['packageId']);
    this.additionalFieldConfig = pak.additionalFrontProfileFields;
    if (!this.route.snapshot.params['frontProfileID']) {
      this.isCreate = true;
      this.createNewProfile();
    } else {
      this.initProfile();
    }
  }

  createNewProfile() {
    this.profile = new Models.FrontProfileModel();
    this.profile.populateFromJSON({
      packageId: this.route.snapshot.params['packageId'],
      currentLanguage: 'de',
      isAnonymous: 0
    });

    if (this.additionalFieldConfig && Object.keys(this.additionalFieldConfig)?.length) {
      this.initAdditionalData();
    }
    this.createPageActions();
  }

  async initProfile() {
    const query = {
      packageId: this.route.snapshot.params['packageId'],
      FrontProfileID: this.route.snapshot.params['frontProfileID']
    };
    const profile = await this.frontProfilesService.find(0, 1, query);
    this.profile = profile.data ? profile.data[0] : null;
    this.createPageActions();
    if (this.additionalFieldConfig) {
      if (this.profile.additionalDataId) {
        this.additionalProfileData = await this.additionalDataService.get(this.profile.additionalDataId);
        this.additionalFieldKeys = Object.keys(this.additionalProfileData.data);
      } else {
        this.initAdditionalData();
      }
    }
  }

  initAdditionalData() {
    this.additionalProfileData = new Models.AdditionalProfileData();
    this.additionalProfileData.populateFromJSON({ data: {} });
    for (const key of Object.keys(this.additionalFieldConfig)) {
      switch (this.additionalFieldConfig[key].type) {
        case 'NUMBER':
          this.additionalProfileData.data[key] = 0;
          break;
        case 'STRING':
          this.additionalProfileData.data[key] = '';
          break;
        default:
          this.additionalProfileData.data[key] = '';
          break;
      }
    }
    this.additionalFieldKeys = Object.keys(this.additionalProfileData.data);
  }

  async saveUser() {
    this.errorMessage = this.testUser();
    if (!this.errorMessage.channel || !this.errorMessage.name) {
      return;
    }
    if (this.profile.channel === 'email') {
      if (!this.errorMessage.mobile) {
        delete this.profile.mobile;
      }
    } else {
      if (!this.errorMessage.email) {
        delete this.profile.email;
      }
    }
    if (this.isCreate) {
      const existingProfile = await this.frontProfilesService.find(0, 1, { packageId: this.profile.packageId, firstName: this.profile.firstName, lastName: this.profile.lastName });
      if (existingProfile?.data?.length) {
        const res = await this.dialogService.confirm('Es existiert bereits ein Benutzer mit den eingegebenen Vor- und Nachnamen, möchten Sie diesen Benutzer wirklich anlegen?');
        if (!res) {
          return;
        }
      }
      if (this.additionalProfileData) {
        const res = await this.additionalDataService.create(this.additionalProfileData);
        this.profile.additionalDataId = res._id;
      }
      const newAccount = await this.accountService.create(new Models.Account());
      this.profile.AccountID = newAccount.AccountID;
      const data = this.clone(this.profile) as any;
      data['backend'] = true;
      const newProfile: any = await this.frontProfilesService.create(data).catch(err => {
        this.accountService.remove(newAccount.AccountID);
        if (err.error && err.error.message) {
          try {
            err = JSON.parse(err.error.message);
            if (err.reason && err.reason === 'tooMany') {
              this.errorMessage.message = 'tooMany';
            }
          } catch (error) {
            console.warn('could not parse error message');
            this.errorMessage.message = 'alreadyExists';
          }
        } else {
          this.errorMessage.message = 'alreadyExists';
        }
        return;
      });
      await this.router.navigate(['my-users', this.route.snapshot.params['packageId'], newProfile.FrontProfileID]);
      this.snackbar.success('Successful created Profile');
    } else {
      if (this.additionalProfileData) {
        if (this.additionalProfileData._id) {
          await this.additionalDataService.update(this.additionalProfileData._id, this.additionalProfileData);
        } else {
          const res = await this.additionalDataService.create(this.additionalProfileData);
          this.profile.additionalDataId = res._id;
        }
      }
      const data = this.clone(this.profile) as any;
      data['backend'] = true;
      await this.frontProfilesService.update(this.profile.FrontProfileID, data).catch(err => {
        if (err && err.error && err.error.message === 'channel already existing') {
          this.errorMessage.message = 'alreadyExists';
        }
      });
      this.snackbar.success('Successful updated Profile');
    }
  }

  private clone(element) {
    const newElement = {};
    for (const key of Object.keys(element)) {
      newElement[key] = element[key];
    }
    return newElement;

  }

  sendInvitationMail() {
    this.frontProfilesService.update(this.profile.FrontProfileID, this.profile, { query: { invitationMail: true } });
  }

  testEmail(email: string): boolean {
    if (!email) {
      return false;
    }
    email = _.trim(email);
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(email.toLowerCase());
  }

  public testMobile(mobile: string): string {
    if (!mobile) {
      return null;
    }
    if (!mobile.startsWith('+')) {
      if (mobile.startsWith('0')) {
        mobile = mobile.substr(1);
      }
      mobile = '+41' + mobile;
    }
    return phone(mobile, null, false)[0];
  }

  testUser(): any {
    const email = this.testEmail(this.profile.email);
    const mobile = this.testMobile(this.profile.mobile);
    if (!!mobile) {
      this.profile.mobile = mobile;
    }
    let channel = !!this.profile.channel;
    let message = 'channel';
    if (channel && this.profile.channel === 'email') {
      channel = email;
      message = channel ? null : 'channelSelect';
    } else if (channel && this.profile.channel === 'mobile') {
      channel = !!mobile;
      message = channel ? null : 'channelSelect';
    }
    if (!mobile && !email) {
      message = 'both';
    }
    let name = true;
    if (channel) {
      if (!this.profile.lastName || !this.profile.firstName || this.profile.firstName.length < 3 || this.profile.lastName.length < 3) {
        name = false;
        if (!this.profile.firstName || this.profile.firstName.length < 3) {
          message = 'firstname';
        } else {
          message = 'lastname';
        }
      }
    }
    return { email, mobile: !!mobile, channel, message, name };
  }

  async deleteGroup(event) {
    await this.groupHasFrontProfileService.remove(event.row.ID);
    this.table.refresh();
  }

  async addLabel(event: any) {
    if (event.target.value === '') {
      return;
    }
    if (this.labels.find(element => {return event.target.value.toLowerCase() === element.title.toLowerCase()})) {
      this.addLabelToProfile(this.labels.find(element => {return event.target.value.toLowerCase() === element.title.toLowerCase()})._id);
      event.target.value = '';
      this.autocomplete.closePanel();
      return;
    }
    const label = new Models.Label();
    label.populateFromJSON({
      color: '#418AC9',
      title: event.target.value,
      packageId: this.route.snapshot.params['packageId']
    });
    const createdLabel = await this.labelService.create(label);
    this.labels.push(createdLabel);
    this.addLabelToProfile(createdLabel._id);
    event.target.value = '';
    this.autocomplete.closePanel();
  }

  removeLabel(label: Models.Label) {
    const regex = new RegExp(`${label._id},`, 'gmi');
    this.profile.labelIds = this.profile.labelIds.replace(regex, '');
  }

  addExistingLabel(label: Models.Label) {
    const target: any = document.getElementById('labelInput');
    target.value = '';
    this.autocomplete.closePanel();
    this.addLabelToProfile(label._id);
  }

  addLabelToProfile(id) {
    if (!this.profile.labelIds) {
      this.profile.labelIds = '';
    }
    if (this.profile.labelIds.includes(id)) {
      return;
    } else {
      this.profile.labelIds += id + ',';
    }
  }

  getTitle() {
    let res = '';
    if (!this.isCreate && this.profile) {
      if (this.profile.firstName || this.profile.lastName) {
        res = ': ' + (this.profile.firstName && this.profile.lastName ? this.profile.firstName + ' ' + this.profile.lastName : (this.profile.firstName || this.profile.lastName));
      } else {
        res = ': ' + (this.profile.channel === 'email' ? this.profile.email : this.profile.mobile);
      }
    }
    return res;
  }

  async addToGroup() {
    let chatGroupException = false;
    const groupHasFrontProfiles = await this.groupHasFrontProfileService.find(0, 1000, this.params)
    this.groupHasFrontProfiles = groupHasFrontProfiles.data;
    const groupIds = await this.getGroupIds();
    const dialogRef = this.dialog.open(GroupSelectionComponent, {
      data: { ProfileID: this.route.snapshot.params['frontProfileID'], params: { GroupID: { $in: groupIds } }, assignedGroupIds: _.map(groupHasFrontProfiles.data, 'GroupID') },
      width: '800px'
    });
    const result: any = await dialogRef.afterClosed().toPromise();
    if (!result || !result.added || !result.removed) {
      return;
    }
    for (const id of result.added) {
      const data = new Models.GroupHasFrontProfile();
      data.populateFromJSON({
        GroupID: id, ProfileID: this.route.snapshot.params['frontProfileID']
      });
      await this.groupHasFrontProfileService.create(data).catch(err => {
        if (err && err.error && err.error.message) {
          try {
            if (JSON.parse(err.error.message).reason === 'tooManyChat') {
              chatGroupException = true;
              const text = 'Could not add Profile to Chat Group(s) because chat profile limit is reached, please remove other profiles or contact [EMAIL ADDRESS]';
              this.snackbar.open(text, 10000);
            }
          } catch (parseErr) {
            console.warn('error parsing error', err, parseErr);
          }
        }
      });
    }
    for (const id of result.removed) {
      const element = _.filter(this.groupHasFrontProfiles, { 'GroupID': id })[0];
      await this.groupHasFrontProfileService.remove(element['ID'].toString());
    }
    if (!chatGroupException) {
      this.snackbar.success('Profile has been added to Group(s)');
    }
    this.table.refresh();
  }

  async getGroupIds(): Promise<string[]> {
    const roles: string[] = _.map(this.messengerService.$activeRoles.getValue(), 'roleName');
    let groupIds: string[] = [];
    if (roles.includes('securedContent') || roles.includes('myUserManager')) {
      const groups = await this.ghrioService.find(0, 100, { roleName: 'securedContent', OrganisationID: this.messengerService.$activeOrganisation.getValue().OrganisationID });
      groupIds = groupIds.concat(groups.data.map(g => g.GroupID));
    }
    if (roles.some(str => ['chatModuleAdmin', 'orderModuleAdmin', 'ticketingModuleAdmin'].includes(str))) {
      let roleNames: string[] = [];
      roleNames = roleNames.concat(roles.indexOf('chatModuleAdmin') > -1 ? ['chatModule', 'chatModuleAdmin'] : []);
      roleNames = roleNames.concat(roles.indexOf('ticketingModuleAdmin') > -1 ? ['ticketingModule', 'ticketingModuleEditor'] : []);
      roleNames = roleNames.concat(roles.indexOf('orderModuleAdmin') > -1 ? ['orderModule'] : []);
      const groups = await this.ghrioService.find(0, 100, { roleName: { $in: roleNames }, OrganisationID: this.messengerService.$activeOrganisation.getValue().OrganisationID });
      groupIds = groupIds.concat(_.map(groups.data, 'GroupID'));
    }
    return groupIds;
  }

  createPageActions() {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Overview',
        translationString: 'general.back',
        callback: () => {
          this.router.navigate(['my-users', this.route.snapshot.params['packageId']]);
        }
      }),
      new PageAction({
        icon: 'save',
        title: 'Save',
        translationString: 'general.save',
        callback: () => {
          this.saveUser();
        }
      })
    ];
    if (this.profile && this.profile.FrontProfileID) {
      this.pageActions.push(new PageAction({
        icon: 'email',
        title: 'Send Invitation mail',
        translationString: 'myUsers.sendInvitation',
        callback: () => {
          this.sendInvitationMail();
        }
      }));
    }
  }

  getRgba(val: string): string {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(val);
    return parseInt(result[1], 16) + ', ' + parseInt(result[2], 16) + ', ' + parseInt(result[3], 16);
  }
}
